import { GET, PATCH } from '@/shared/api/requests';

export interface UserProfile {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  job_title: string;
  phone_number?: string;
  client: {
    id: number;
    name: string;
  };
  is_staff: boolean;
  is_superuser: boolean;
  date_joined: string;
  prefers_dark: boolean;
}

export interface UpdateProfileData {
  first_name?: string;
  last_name?: string;
  job_title?: string;
  phone_number?: string;
  prefers_dark?: boolean;
}

/**
 * Get current user's profile
 */
export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await GET('users/profile/');
  return response.data;
};

/**
 * Update user profile
 */
export const updateUserProfile = async (data: UpdateProfileData): Promise<UserProfile> => {
  const response = await PATCH('users/profile/', data);
  return response.data;
};

